export enum EErrorsQueryKey {
  EXISTS_ERROR = 'EXISTS_ERROR',
  ERRORS = 'ERRORS',
  CUSTOMER_ERRORS = 'CUSTOMER_ERRORS',
  DOCUMENTS_ERRORS = 'DOCUMENTS_ERRORS',
  DOCUMENT_ERRORS_DETAILS = 'DOCUMENT_ERRORS_DETAILS',
}
